"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _reactRouterDom = require("react-router-dom"),
    _NotFound = _interopRequireDefault(require("../components/NotFound")),
    _default = (0, _reactRouterDom.withRouter)(_NotFound["default"]);

exports["default"] = _default;